import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { 
  Box, 
  useTheme,
} from '@mui/material';

import { usePagination } from '@frontend/features/common/components/Table';
import { ListLayout } from '@frontend/features/common/components/ListLayout';
import { ListContentLayout } from '@frontend/features/common/components/ListContentLayout';
import {
  useGetHotelCategories,
} from '@frontend/features/hotel-content-manager/queries';
import { InfoLanguage, MultiLanguageText, OrderOptionsValues } from '@bandido/shared/interfaces';

export const CategoriesView = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const pagination = usePagination();
  const [searchText, setSearchText] = useState('');
  const { data: categories, isLoading: isLoadingCategories } = useGetHotelCategories({
    searchText,
    currentPage: pagination.page,
    pageSize: pagination.rowsPerPage,
    sort: 'id',
    order: OrderOptionsValues.asc
  });

  return (
    <>
      <ListLayout 
        title={t('hotelContent.management.categories.title') || 'Categories'} 
        subtitle={t('hotelContent.management.categories.subtitle') || 'Manage and view categories'}
      >
        <ListContentLayout
          pagination={pagination}
          stickyHeader
          onSearchChange={(value: string) => {
            setSearchText(value);
          }}
          columns={[
            {
              id: 'code',
              label: t('hotelContent.management.categories.table.code'),
              align: 'left',
              maxWidth: 100,
            },
            {
              id: 'supplierName',
              label: t('hotelContent.management.categories.table.supplierName'),
              align: 'left',
              minWidth: 100,
            },
            {
              id: 'texts',
              label: t('hotelContent.management.categories.table.texts'),
              align: 'left',
              format: (texts: MultiLanguageText) => (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                  <Box sx={{ fontSize: '0.875rem' }}>
                    {`${InfoLanguage.English}: ${texts[InfoLanguage.English] || t('common.notValueFound')}`}
                  </Box>
                  <Box sx={{ fontSize: '0.75rem', color: theme.palette.text.secondary }}>
                    {`${InfoLanguage.Spanish}: ${texts[InfoLanguage.Spanish] || t('common.notValueFound')}`}
                  </Box>
                  <Box sx={{ fontSize: '0.75rem', color: theme.palette.text.secondary }}>
                    {`${InfoLanguage.Portuguese}: ${texts[InfoLanguage.Portuguese] || t('common.notValueFound')}`}
                  </Box>
                </Box>
              ),
            }
          ]}
          isLoading={isLoadingCategories}
          data={{
            key: 'id',
            items: categories?.items || [],
            totalCount: categories?.count || 0,
          }}
        />
      </ListLayout>
    </>
  );
};
